import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class SalesUnitRepository<
    SalesUnitModel
> extends RepositoryBase<SalesUnitModel> {
    public constructor() {
        super('salesUnit');
    }
}
